module.exports = __webpack_public_path__ + "media/country_flags/bi-82fbafd1.png";